import React from 'react';
import { getCampaignEditPath } from "constants/path"
import Header from "./components/header";
import ListItem from './components/eventDetails';
import useStyles from './style';
import "./style.css"

export default React.memo(({ campaigns, history, onActiveClick, showFilter, onDuplicateCallback, handleFilter, status, noCampaignsView }) => {
  const classes = useStyles();

  const handleOnEdit = (id) => {
    history.push(getCampaignEditPath(id))
  }

  const onPreviewCallback = (item) => {
    window.open(`enroll/${item.id}`)
  }




  const renderCampaign = (item) => (
    <ListItem
      key={item.node.id}
      id={item.node.id}
      item={item.node}
      classes={classes}
      onEdit={handleOnEdit}
      onActiveClick={onActiveClick}
      onPreviewCallback={onPreviewCallback}
      onDuplicateCallback={onDuplicateCallback}
    />
  )

  return (
    <>
      <table id="campaignTable" className={classes.borderTable}>
        <Header classes={classes} status={status} handleFilter={handleFilter} showFilter={showFilter} />
        <tbody>
          {
            (campaigns.length === 0 && typeof noCampaignsView === "function") ? noCampaignsView() : campaigns.map(renderCampaign)
          }
        </tbody>
      </table>
    </>
  );
})
